import { MultilingualLanguages } from '@asgard/common-dto';
import { DEFAULT_LOCALE } from 'services/multilingual.service';

export const getLocale = (
  locale: string | undefined
): MultilingualLanguages => {
  const result = locale ? locale?.toUpperCase() : DEFAULT_LOCALE;
  return result as MultilingualLanguages;
};
